export class DivergenciaCaixaGeralTO {
    idPosto: number;
    idCaixa: number;
    valor: number;
}
